import axios from 'axios';
import { GIFT_TABLE_ROOT as ROOT, BASE_PATH_API } from 'constants/env';
import {
  transformListParams,
  transformListRes,
} from 'services/commons/transformers';

export function getFAQs(params = {}) {
  const transformedParams = transformListParams(params);

  return axios({
    url: `${BASE_PATH_API}/${ROOT}/faq`,
    params: transformedParams,
  })
    .then((res) => res)
    .then((res) => {
      const { data, pagination } = res.data;

      const listResponse = transformListRes(data, pagination);

      return [listResponse];
    });
}
